<template>
  <div class="login">
    <AppNavbar title="" :zIndex="1000" :placeholder="true"> </AppNavbar>
    <div class="content">
      <div class="title">手机号登录/注册</div>
      <div class="desc">上betterWEApp 1000名专业营养师为您纠正饮食误区</div>
      <div class="form-list">
        <div class="form-item">
          <div class="area-code">+86</div>
          <!--  <input class="input" type="number" placeholder="请输入手机号" v-model="phone" maxlength="11"> -->
          <van-field
            class="input"
            v-model="phone"
            placeholder="请输入手机号"
            :maxlength="phoneLength"
          />
        </div>
        <div class="form-item">
          <!--  <input class="input" type="number" placeholder="请输入手机验证码" v-model="code" maxlength="4"> -->
          <van-field
            class="input"
            v-model="code"
            placeholder="请输入手机验证码"
            maxlength="4"
          />
          <div class="send-code" @click="bindSend">{{
            disabledSend ? curSendTime + '秒' : '获取验证码'
          }}</div>
        </div>
      </div>
      <div class="login-btn" @click="bindLogin">确认登录</div>
      <div class="agree"
        ><span class="gou" @click="bindToggleAgree"
          ><span v-if="agree" class="iconfont icon-gou"></span></span
        ><span>我已阅读并同意</span
        ><span class="blue" @click="bindClickAgreement"
          >《隐私政策》《用户协议》</span
        >
      </div>
    </div>
  </div>
</template>
<script>
import AppNavbar from '@/components/app/nav-bar/index.vue'
export default {
  name: 'dounyin-integral-exchange-login',
  components: {
    AppNavbar
  },
  data() {
    return {
      phoneLength: 11, //手机号码长度
      phone: '',
      code: '',
      agree: false,
      disabledSend: false,
      sendLimitTime: 60, //发送的限制时间为60s
      curSendTime: 0 //当前倒计时
    }
  },
  activated() {
    this.$http.bindPageUMA()
  },
  created() {
    this.checkLogin()
    this.gym_code = this.$http._getCookie('token')
    if (!this.gym_code) {
      this.$toast('微信授权失败，请关闭页面重试')
    }
  },
  methods: {
    checkLogin() {
      this.gym_code = this.$http._getCookie('token')
      if (!this.gym_code && !this.$route.query.refresh) {
        let url = location.href
        let params = url.includes('?') ? '&refresh=1' : '?refresh=1'
        url = url + params
        location.href =
          'http://auth3.gymcity.com.cn/?auth=wegymer&scope=snsapi_userinfo&next=' +
          encodeURIComponent(url)
      }
    },
    bindClickAgreement() {
      this.$router.push('/privacy-agreement')
    },
    bindToggleAgree() {
      this.agree = !this.agree
    },
    bindLogin() {
      if (!this.gym_code) {
        this.$toast('微信授权失败，请关闭页面重试')
        return
      }
      if (!this.checkParams()) {
        return
      }
      let params = {
        phone: this.phone,
        code: this.code,
        gym_code: this.gym_code
      }
      this.$http
        .postApp('api/v1/IntegralConversionCenter/login', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('登录成功')
            localStorage.setItem('dy-integral-token', res.data.token)
            sessionStorage.setItem('dy-integral-token', res.data.token)
            this.$http._setCookie('dy-integral-token', res.data.token)
            sessionStorage.setItem('dy-integral-exchange-login', true)
            this.$router.go(-1)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    bindSend() {
      if (this.disabledSend) {
        return
      }
      if (!this.phone) {
        this.$toast('手机号不能为空')
        return
      }
      if (this.phone.length != this.phoneLength) {
        this.$toast('手机号不足11位数')
        return
      }
      let params = {
        phone: this.phone
      }
      this.$http
        .postApp('api/v1/IntegralConversionCenter/sendSms', params)
        .then((res) => {
          res = res.data
          if (res.code == 200) {
            this.$toast('发送成功')
            this.curSendTime = this.sendLimitTime
            this.disabledSend = true
            if (this.timer) {
              clearInterval(this.timer)
            }
            this.timer = setInterval(() => {
              if (this.curSendTime > 1) {
                this.curSendTime--
              } else {
                this.disabledSend = false
                clearInterval(this.timer)
              }
            }, 1000)
          } else {
            this.$toast(res.msg)
          }
        })
        .catch(() => {
          this.$toast('异常错误')
        })
    },
    checkParams() {
      if (!this.phone) {
        this.$toast('手机号不能为空')
        return false
      } else if (this.phone.length != 11) {
        this.$toast('手机号不足11位数')
        return false
      } else if (!this.code) {
        this.$toast('验证码不能为空')
        return false
      } else if (!this.agree) {
        this.$toast('您还未同意用户协议')
        return false
      }
      return true
    }
  }
}
</script>
<style lang="scss" scoped>
.login {
  padding: 20px;

  .back {
    font-size: 20px;
    margin-bottom: 21px;
  }

  .content {
    padding: 0 10px;

    .title {
      font-size: 22px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.8);
      line-height: 30px;
      margin-bottom: 7px;
    }

    .desc {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.5);
      line-height: 17px;
      margin-bottom: 40px;
    }

    .form-list {
      .form-item {
        padding: 14px;
        border-top: 1px solid #f7f7f7;
        display: flex;
        align-items: stretch;

        .area-code {
          padding-right: 14px;
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 600;
          color: rgba(0, 0, 0, 0.8);
          line-height: 22px;
          border-right: 1px solid #f7f7f7;
        }

        .input {
          flex: 1;
          padding: 0px 10px;
          height: 26px;
          border: none;
          outline: none;
        }

        .send-code {
          width: 86px;
          height: 30px;
          border-radius: 15px;
          border: 1px solid rgba(105, 136, 255, 0.5);
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #6988ff;
          line-height: 30px;
          text-align: center;
        }

        ::v-deep .van-cell::after {
          display: none;
        }
      }

      .form-item:last-child {
        border-bottom: 1px solid #f7f7f7;
      }
    }

    .login-btn {
      height: 44px;
      background: #fa2c19;
      border-radius: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: #ffffff;
      line-height: 44px;
      text-align: center;
      margin-top: 40px;
      margin-bottom: 30px;
    }

    .agree {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #999999;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;

      .gou {
        width: 12px;
        height: 12px;
        border-radius: 50%;
        border: 1px solid #999;
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        .iconfont {
          font-weight: 600;
          font-size: 12px;
          color: #fa2c19;
        }
      }

      .blue {
        color: rgba(105, 136, 255, 1);
      }
    }
  }
}
</style>
